<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col class="animated fadeIn" cols="12">
        <c-paginate table-uri="paginate/table/faqs" caption="Preguntas frecuentes"  :fields="fields" new-item-name="Nueva pregunta" edit-name="Detalle de pregunta"></c-paginate>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import axios from 'axios'
  import _ from 'lodash'

  export default {
    name: 'FaqsIndex',
    data: () => {
      return {
        fields: [
          {
            key: 'pregunta',
          },
          {
            key: 'disponibilidad',
          },
          {
            key: '_',
            label: ' '
          }
        ]
      }
    }
  }

</script>
